import { useTheme } from '@mui/system';
import { FC } from 'react';

import { Statuses } from '../StatusCell';

interface StatusTextProps {
  status: Statuses;
  value: string;
}

export const StatusTextCell: FC<StatusTextProps> = ({ status, value }) => {
  const { palette } = useTheme();

  const getStatusColor = () => {
    switch (true) {
      case ['succeed', 'success', 'approved', 'payout'].includes(status.toLowerCase()):
        return palette.success[palette.mode];

      case ['failed', 'rejected', 'cancel'].includes(status.toLowerCase()):
        return palette.error[palette.mode];

      default:
        return palette.warning[palette.mode];
    }
  };

  const color = getStatusColor();
  const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);

  return <span style={{ color: color }}>{capitalizedValue}</span>;
};
